var _style, _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpeningGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 276 41.1",
    style: {
      enableBackground: "new 0 0 276 41.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000044868699823894085500000017226751895838544305_);}\r\n\t.st1{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -1780,
    y: 1308,
    width: 1920,
    height: 1080
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000053518187986643468190000008405000965809898647_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000053518187986643468190000008405000965809898647_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 3864,
    height: 5050,
    xlinkHref: "DE98D43E.png",
    transform: "matrix(1 0 0 1 -2750 -662.96)"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 276,
    height: 41.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.4,23.6h-6l-1.3,3.5h-1.3l5-13h1.3l4.9,13h-1.3L28.4,23.6z M28,22.5l-2.6-6.8l-2.6,6.8H28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.8,23.6h-6l-1.3,3.5h-1.3l5-13h1.3l4.9,13h-1.3L41.8,23.6z M41.3,22.5l-2.6-6.8l-2.6,6.8H41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.1,26.4l1.4,2.3l-1,0.6l-1.5-2.4c-0.7,0.3-1.5,0.4-2.3,0.4c-3.7,0-6.6-3-6.6-6.7c0-3.7,2.9-6.8,6.6-6.8 c3.7,0,6.6,3.1,6.6,6.8C60.3,23.1,59,25.2,57.1,26.4z M55.4,25.9l-1.5-2.4l1-0.6l1.6,2.5c1.6-1,2.6-2.8,2.6-4.8 c0-3-2.3-5.6-5.3-5.6c-3,0-5.3,2.6-5.3,5.6c0,3,2.3,5.5,5.3,5.5C54.3,26.1,54.9,26,55.4,25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.1,14.1h1.2v13h-1.2V14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.9,25.9v1.2h-6.8v-13h1.2v11.8H78.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.9,25.9v1.2h-6.8v-13h1.2v11.8H89.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.2,18c0,2-1.1,4-3.8,4h-3.8v5.1h-1.2v-13h5.1C108.1,14.1,109.2,16,109.2,18z M108,18 c0-1.4-0.7-2.8-2.5-2.8h-3.9v5.6h3.8C107.2,20.8,108,19.5,108,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.4,14.1v13h-1.2v-5.9H115v5.9h-1.2v-13h1.2v6h7.2v-6H123.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.1,20.6c0-3.7,2.9-6.8,6.6-6.8c3.7,0,6.6,3.1,6.6,6.8c0,3.7-2.9,6.7-6.6,6.7 C131,27.3,128.1,24.3,128.1,20.6z M140,20.6c0-3-2.3-5.6-5.3-5.6s-5.3,2.6-5.3,5.6c0,3,2.3,5.5,5.3,5.5S140,23.6,140,20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.4,15.2h-4.2v11.8H148V15.2h-4.1v-1.2h9.5V15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156,20.6c0-3.7,2.9-6.8,6.6-6.8c3.7,0,6.6,3.1,6.6,6.8c0,3.7-2.9,6.7-6.6,6.7C158.9,27.3,156,24.3,156,20.6z  M167.9,20.6c0-3-2.3-5.6-5.3-5.6c-3,0-5.3,2.6-5.3,5.6c0,3,2.3,5.5,5.3,5.5C165.6,26.1,167.9,23.6,167.9,20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173,20.6c0-3.7,2.9-6.8,6.6-6.8c1.6,0,3,0.6,4.2,1.5l-0.8,0.8c-0.9-0.7-2.1-1.2-3.3-1.2 c-3,0-5.3,2.6-5.3,5.6c0,3,2.3,5.5,5.3,5.5c2.6,0,4.6-1.7,4.7-4.2h-3.9v-1.1h5.3c-0.1,4.4-2.5,6.5-6.1,6.5 C175.9,27.3,173,24.3,173,20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.1,22l3.6,5.1h-1.5l-3.6-5.1h-2.2v5.1h-1.2v-13h4.8c2.7,0,3.8,2,3.8,4C198.8,20,197.7,22,195.1,22 L195.1,22z M191.4,20.8h3.3c2,0,2.8-1.2,2.8-2.8s-0.8-2.8-2.5-2.8h-3.6V20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.5,23.6h-6l-1.3,3.5h-1.3l5-13h1.3l4.9,13h-1.3L210.5,23.6z M210.1,22.5l-2.6-6.8l-2.6,6.8H210.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225.9,18c0,2-1.1,4-3.8,4h-3.8v5.1h-1.2v-13h5.1C224.8,14.1,225.9,16,225.9,18z M224.6,18 c0-1.4-0.7-2.8-2.5-2.8h-3.8v5.6h3.8C223.9,20.8,224.6,19.5,224.6,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240,14.1v13h-1.2v-5.9h-7.2v5.9h-1.2v-13h1.2v6h7.2v-6H240z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.1,14.1l-5,6.9v6.1h-1.2V21l-4.9-6.9h1.5l4.1,5.7l4.1-5.7H255.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpeningGraphic);
export default __webpack_public_path__ + "static/media/opening-graphic.11984d7976c171999bd70ac25304d512.svg";
export { ForwardRef as ReactComponent };